
import fingerprint from '~/mixins/fingerprint'
import interRegister from '~/mixins/pages/register/interRegister'
export default {
    mixins: [fingerprint, interRegister],
    props: {
        toggle: {
            type: Function,
            default: () => {},
        },
    },
    data() {
        return {
            acceptCondition1: true,
            acceptCondition2: false,
        }
    },
    async mounted() {
        const countryCode = this.$cookie?.get('country_code')
        await this.countryChange(countryCode)
        this.form.reg_fingerprint = await this.visitorId()
        this.form.country_code = countryCode
        const globalReg = this.$cookie?.get('global_reg')
        this.globalReg = globalReg
    },
    methods: {
        register() {
            this.$refs?.refRegister?.validate()
            if (this.formValid && this.acceptCondition1) {
                this.onRegister()
            }
        },
    },
}
